import { render } from "./MyBookmarksView.vue?vue&type=template&id=07a433e4&scoped=true"
import script from "./MyBookmarksView.vue?vue&type=script&lang=js"
export * from "./MyBookmarksView.vue?vue&type=script&lang=js"

import "./MyBookmarksView.vue?vue&type=style&index=0&id=07a433e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a433e4"]])

export default __exports__